import * as React from "react";
import { MemorySave, type BlockReceipt } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

export function MemorySaveDemo() {
  const [receipt, setReceipt] = React.useState<BlockReceipt | undefined>(undefined);

  return (
    <Section
      id="memory-save"
      title="MemorySave"
      description="The 'save this to memory?' post-process signal (INTERACTIVE). Renderer for the K2 `memory_save` block (ais-agent-runtime#115) - props are `{ text, submit_to?, receipt? }`. Save emits the shared block-submit event with the candidate text; dismiss emits a value-less dismiss. Settles into a receipt either way."
    >
      <VariantBlock label="Live affordance -> settled receipt" caption="save or dismiss">
        <div className="w-full max-w-xl">
          <MemorySave
            text="Prefers concise answers with a code example first"
            receipt={receipt}
            onSave={() =>
              setReceipt({
                outcome: "success",
                summary: "Saved to memory",
                at: new Date().toISOString(),
              })
            }
            onDismiss={() =>
              setReceipt({
                outcome: "cancelled",
                summary: "Not saved",
                at: new Date().toISOString(),
              })
            }
          />
          {receipt ? (
            <button
              type="button"
              className="mt-3 text-xs text-muted-foreground underline underline-offset-2 hover:text-foreground"
              onClick={() => setReceipt(undefined)}
            >
              Reset
            </button>
          ) : null}
        </div>
      </VariantBlock>

      <VariantBlock label="Pre-settled (history reload)">
        <div className="w-full max-w-xl">
          <MemorySave
            text="Works in EST, prefers async updates"
            receipt={{ outcome: "success", summary: "Saved to memory", at: "2026-06-20T09:15:00Z" }}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="In flight (disabled)">
        <div className="w-full max-w-xl">
          <MemorySave text="Ships releases on Fridays" disabled />
        </div>
      </VariantBlock>
    </Section>
  );
}
